import { StyleSheet } from 'react'
import './index.css'

const PageBg = (props) => {
  return (
    <section className={props.className}>
      <div className="page-bg-1"></div>
      <div className="page-bg-2"></div>
      <div className="page-bg-3"></div>
    </section>
  )
}

export default PageBg
